<template>
  <b-badge
    :class="badgeClass"
    :variant="variant"
    v-b-tooltip.hover="{
      title: tooltipTitle,
      html: true,
      disabled: disabled,
    }">
    {{ value }}
  </b-badge>
</template>

<script>
  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Badge',
    props: {
      variant: {
        required: false,
        type: String,
        default: 'success',
      },
      value: {
        required: true,
        type: String,
      },
      tooltipTitle: {
        required: true,
        type: String,
      },
      badgeClass: {
        required: false,
        type: String,
        default: '',
      },
    },
    computed: {
      disabled() {
        return !this.tooltipTitle;
      },
    },
  };
</script>
